import React from 'react';
import { FaTimes, FaCheck } from 'react-icons/fa';
import Modal from './Modal';

// Delegates its chrome (backdrop, card, enter/exit motion) to the shared
// Modal rather than duplicating it — this used to render its own bespoke
// backdrop/card with no transition at all.
const ConfirmationModal = ({
  open,
  title,
  message,
  onClose,
  onConfirm,
  confirmText = 'Confirm',
  cancelText = 'Cancel'
}) => {
  return (
    <Modal open={open} onClose={onClose} title={title}>
      <p className="mb-4">{message}</p>
      {onConfirm ? (
        <div className="flex flex-wrap justify-end gap-2">
          <button onClick={onClose} className="btn-outline">
            <FaTimes />
            {cancelText}
          </button>
          <button
            onClick={() => {
              onConfirm();
            }}
            className="btn-primary"
          >
            <FaCheck />
            {confirmText}
          </button>
        </div>
      ) : (
        <div className="text-right">
          <button onClick={onClose} className="btn-outline">
            <FaTimes />
            Close
          </button>
        </div>
      )}
    </Modal>
  );
};

export default ConfirmationModal;
